import { render, staticRenderFns } from "./prewarn-table.vue?vue&type=template&id=19c4b868&scoped=true"
import script from "./prewarn-table.vue?vue&type=script&lang=js"
export * from "./prewarn-table.vue?vue&type=script&lang=js"
import style0 from "./prewarn-table.vue?vue&type=style&index=0&id=19c4b868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4b868",
  null
  
)

export default component.exports